import types from './types'
import generateUniqueId from './uniq-id'

const DEFAULT_TIMEOUT = 3000

const addSnackbarItem = (message, timeout = DEFAULT_TIMEOUT) => {
  return (dispatch) =>
    dispatch({
      type: types.ADD_SNACKBAR_ITEM,
      payload: {
        key: generateUniqueId(),
        message,
        dismissAfter: timeout,
      },
    })
}
const dismissSnackbarItem = (notification) => {
  return (dispatch) =>
    dispatch({
      type: types.DISMISS_SNACKBAR_ITEM,
      payload: notification,
    })
}

export default {
  addSnackbarItem,
  dismissSnackbarItem,
}
